var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_vm._m(0),_c('ResetPassword')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"container d-flex justify-content-center"},[_c('img',{staticStyle:{"height":"120px","width":"90%","object-fit":"contain"},attrs:{"src":require("@/assets/ross.png"),"alt":"logo"}})])])
}]

export { render, staticRenderFns }